import { useState } from "react";
import { Link } from "react-router-dom";
import { FOOTER_LINKS } from "../../../constant/menulist";
import { SUPPORT_EMAIL, SUPPORT_HOURS } from "../../../constant/contact";
import PolicyDialog from "../../dialog/policy-dialog/policy-dialog";
import "./site-footer-style.scss";

//全站頁尾
//  純手機版：品牌 → 說明連結 → 聯絡資訊。
//  公司資訊之後由法務確認後替換，這裡先放可辨識的佔位。
//
//  ⚠️ 原本「服務」那一欄列的是 CATEGORY_TABS（戀愛／財運／事業／合盤／綜合），
//  2026-10-20 拿掉。理由是頂部那排分類標籤已經收起來了（見 nav-list 的
//  SHOW_CATEGORY_TABS）—— 入口都關了，只剩頁尾還留著一條通往空清單的路，
//  點進去是「還沒有開放的服務」。分類要回來的話兩邊一起回。
//
//  拿掉之後「服務／說明」的兩欄並排只剩一欄，右半會空著，
//  所以順手把說明改成一排可換行的連結 —— 四條短連結本來就不需要佔一整欄。
//
//  —— 條款走 dialog，不導頁 ——
//  使用條款與隱私權政策原本指向 /policy，但那條 route 不存在，點下去是白頁。
//  全站的法律條文都在 policy-dialog 裡（購買彈窗也是從那裡開的），
//  所以這裡直接開同一支 —— 再做一頁等於同一份條文有兩個來源。
const SiteFooter = () => {
  //null = 沒開。值是 policy-dialog 的 doc（privacy / terms / marketing）
  const [doc, setDoc] = useState(null);

  return (
    <footer className="ft">
      <div className="ft__inner">
        <div className="ft__brand">
          <span className="ft__logo">閻異閣</span>
          <p className="ft__slogan">命理 AI 數位生成報告系統</p>
        </div>

        {/* 說明：一排可換行的連結，不再是一整欄。
            三種去處看 menulist 的 FOOTER_LINKS：doc 開條款 dialog、
            href 另開站外分頁、path 走站內導頁。
            key 用 label 不用 path —— 只有 path 那一種才有 path。 */}
        <nav className="ft__links">
          {FOOTER_LINKS.map((l) => {
            if (l.doc) {
              return (
                <button
                  key={l.label}
                  type="button"
                  onClick={() => setDoc(l.doc)}
                >
                  {l.label}
                </button>
              );
            }

            //站外連結要 noreferrer：少了它，對方的頁面可以透過
            //  window.opener 回頭操作我們這一頁。
            if (l.href) {
              return (
                <a key={l.label} href={l.href} target="_blank" rel="noreferrer">
                  {l.label}
                </a>
              );
            }

            return (
              <Link key={l.label} to={l.path}>
                {l.label}
              </Link>
            );
          })}
        </nav>

        {/* 聯絡資訊。不給標題 —— 信箱與服務時間這兩行自己說明了自己，
            而「聯絡客服」這個名目已經由上面那排的官方 LINE 擔著了。

            原本「聯絡客服」是一條指向 /support 的連結，但那條 route
            不存在，點下去是白頁。現在信箱本身就是 mailto，點了直接開信。 */}
        <div className="ft__col ft__col--info">
          {/* TODO: 公司登記資訊待法務確認後替換 */}
          <p>
            客服信箱：
            <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
          </p>
          <p>服務時間：{SUPPORT_HOURS}</p>
        </div>
      </div>

      <div className="ft__bottom">
        <span>Copyright © {new Date().getFullYear()} Leinotek — 版權所有</span>
        <span className="ft__disclaimer">
          本站內容由 AI 生成，僅供參考與自我探索，不構成醫療、法律或投資建議。
        </span>
      </div>

      <PolicyDialog open={!!doc} doc={doc} onClose={() => setDoc(null)} />
    </footer>
  );
};

export default SiteFooter;
